import { useParams } from 'react-router-dom'
import Card from 'components/card/Card'
import CardHeaderForm from 'components/card/CardHeaderForm'
import FormSection1 from '../components/voucher/FormSection1'
import FormSection2 from '../components/voucher/FormSection2'
import FormSection3 from '../components/voucher/FormSection3'
import React, { useEffect } from 'react'
import { useFormik } from 'formik'
import { useVoucherForm } from '../hooks/useVoucherForm'

export default function Detail() {
  const { id } = useParams()
  const useVoucherFormHook = useVoucherForm()

  useEffect(() => {
    if (id) {
      useVoucherFormHook.getVoucherDetail(id)
    }
  }, [id])

  const formik = useFormik({
    initialValues: useVoucherFormHook.voucherForm,
    enableReinitialize: true,
    onSubmit: async () => {
      // do nothing
    },
  })

  const loading = useVoucherFormHook.statusFetchVoucher === 'loading'

  return (
    <div className="content-wrapper">
      <Card className="bg-transparent p-0" dataTestId="card_voucherForm" loading={loading}>
        <Card className="rounded-xl py-6 px-0 mb-4" dataTestId="card_formSection1">
          <CardHeaderForm title="1. Informasi Voucher" />
          <Card.Body className="mt-0 px-6">
            <FormSection1 formikProps={formik} disabledForm={true} />
          </Card.Body>
        </Card>
        <Card className="rounded-xl py-6 px-0 mb-4" dataTestId="card_formSection2">
          <CardHeaderForm title="2. Pengaturan Voucher" />
          <Card.Body className="mt-0 px-6">
            <FormSection2 formikProps={formik} disabledForm={true} />
          </Card.Body>
        </Card>
        <Card className="rounded-xl py-6 px-0" dataTestId="card_formSection3">
          <CardHeaderForm title="3. Kriteria Voucher" />
          <Card.Body className="mt-0 px-6">
            <FormSection3
              formikProps={formik}
              statusFetchStockLocations={useVoucherFormHook.statusFetchStockLocations}
              statusFetchCategories={useVoucherFormHook.statusFetchCategories}
              tableHeight={useVoucherFormHook.maxHeightTable}
              tableContainerRef={useVoucherFormHook.tableContainerRef}
              stockLocations={useVoucherFormHook.stockLocations}
              categories={useVoucherFormHook.categories}
              fetchStockLocations={useVoucherFormHook.fetchStockLocation}
              fetchCategories={useVoucherFormHook.fetchCategories}
              resetFetchStockLocation={useVoucherFormHook.resetFetchStockLocations}
              disabledForm={true}
            />
          </Card.Body>
        </Card>
      </Card>
    </div>
  )
}
